export const HEADERS = [
  {
    slug: 'agencyName',
    label: 'Agency Name'
  },
  {
    slug: 'agencyNumber',
    label: 'Agency Number'
  },
  {
    slug: 'state',
    label: 'State'
  },
  {
    slug: 'prefix',
    label: 'Prefix'
  },
  {
    slug: 'powerNumber',
    label: 'Power Number'
  },
  {
    slug: 'bondStatus',
    label: 'Bond Status'
  },
  {
    slug: 'executionDate',
    label: 'Execution Date'
  },
  {
    slug: 'defendantNameLast',
    label: 'Defendant Last Name'
  },
  {
    slug: 'defendantNameFirst',
    label: 'Defendant First Name'
  },
  {
    slug: 'defendantNameMiddle',
    label: 'Defendant Middle Name'
  },
  {
    slug: 'caseNumber',
    label: 'Case Number'
  },
  {
    slug: 'writingAgentLastName',
    label: 'Writing Agent Last Name'
  },
  {
    slug: 'writingAgentFirstName',
    label: 'Writing Agent First Name'
  },
  {
    slug: 'bondAmount',
    label: 'Bond Amount'
  },
  {
    slug: 'premiumAmount',
    label: 'Premium Amount'
  },
  {
    slug: 'netPremium',
    label: 'New Premium'
  },
  {
    slug: 'collateralBuff',
    label: 'Collateral BUF'
  },
  {
    slug: 'calculatedRate',
    label: 'Calculate Rate'
  },
  {
    slug: 'calculatedBuff',
    label: 'Calculated Buff'
  },
  {
    slug: 'isCorrect',
    label: 'Is Correct'
  }
]

export const DEFAULT_POWER = {
  bondStatus: 'EXECUTED',
  rateOverride: false,
  buffOverride: false
}